module.exports = __webpack_public_path__ + "static/img/bee.ed233fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Log/imgs/bee.png
// module id = CW9v
// module chunks = 1